/**
 * contact-validation.ts — Validation de format des champs contact (email / telephone)
 *
 * Les deux champs sont OPTIONNELS : une valeur vide est consideree valide.
 * On ne valide le format que lorsqu'une valeur est saisie, pour bloquer
 * la creation de contacts non-joignables (ex: email "pasunemail", tel "abc").
 */

// Meme motif que celui deja utilise dans CadastreRequestDialog (coherence projet).
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Chiffres + separateurs usuels uniquement (espace, point, tiret, parentheses),
// avec un eventuel prefixe "+". Toute lettre rend le numero invalide.
const PHONE_ALLOWED = /^\+?[\d\s.\-()]+$/;

/** Email optionnel : vide = valide, sinon doit matcher un format email simple. */
export function isValidEmail(email: string | null | undefined): boolean {
  const trimmed = (email ?? "").trim();
  if (trimmed === "") return true;
  return EMAIL_REGEX.test(trimmed);
}

/**
 * Telephone optionnel : vide = valide. Sinon : caracteres autorises uniquement
 * et entre 8 et 15 chiffres (FR = 10, international = jusqu'a 15 selon E.164).
 */
export function isValidPhone(phone: string | null | undefined): boolean {
  const trimmed = (phone ?? "").trim();
  if (trimmed === "") return true;
  if (!PHONE_ALLOWED.test(trimmed)) return false;
  const digits = trimmed.replace(/[^\d]/g, "");
  return digits.length >= 8 && digits.length <= 15;
}
